<template>
  <div>
    <form-header
        :show-save-edit="false"
        @delete="deleteNotification"
        :show-history="true"
    ></form-header>
    <b-container fluid>
      <b-row>
        <b-col class="p-3 font-weight-bold">
          {{ dateOfNotification }}
        </b-col>
        <b-col class="p-3 text-right">
          <font-awesome-icon
              v-if="notificationIcon !== ''"
              :class="notificationIconColor"
              :icon="notificationIcon">
          </font-awesome-icon>
        </b-col>
      </b-row>
    </b-container>
    <v-box :scrollable="true">
      <div class="border-info">
        <h5 class="font-weight-bold text-center" v-html="notification.headline"></h5>
        <h6 class="pl-5 p-3 m-0" v-html="notification.body"></h6>
        <b-link class="pl-5" v-if="notificationWithTransition" @click="moveToBusinessEntity">To go to the record
          click here.
        </b-link>
      </div>
    </v-box>
    <FooterNavbar data-test-path="notifications-footer">
      <CloseButton @close="markAsReed"></CloseButton>
    </FooterNavbar>
  </div>
</template>

<script>
import Activity from "@/activity/Activity";
import moment from "moment-timezone";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FooterButton from "@/components/navbar/FooterButton";
import CloseButton from "@/components/navbar/CloseButton";
import FormHeader from "@/components/forms/FormHeader";
import FormsActions from "@/components/forms/FormsActions";
import OrderDetails from "@/server/com/silkplm/model/plm/OrderDetails";

moment.suppressDeprecationWarnings = true;

export default {
  name: "NotificationDetails",
  components: {FormHeader, CloseButton, FooterButton, VBox, FooterNavbar},

  async created() {
    await this.loadNotificationData();
  },

  async mounted() {
    this.afterStart(async () => {
      this.checkIfNotificationHasATransition();
      // this.checkIfNotificationHasATransitionMoveToOrderDetailsList();
    });
  },

  methods: {
    ...Activity.methods,

    getTitle() {
      return $tr("notification","Notification");
    },

    beforeClose() {
    },

    async canClose() {
      return true;
    },

    checkIfNotificationHasATransition() {
      let path = this.notification.body;
      const pattern = /(.*)(#NOTIFICATION_LINK-)(.*)(ENTITYCLASS)(((\w+)*([\.])*)*)/;
      const match = path.match(pattern);
      if (match) {
        this.notificationWithTransition = true;
        this.entityId = match[3];
        this.entityClazz = match[5];
        path = path.replace(match[2], "");
        path = path.replace(match[3], "");
        path = path.replace(match[4], "");
        path = path.replace(match[5], "");
        this.notification.body = path;
      }
      const patternDate = /\d{2}[./-]\d{2}[./-]\d{4}|\d{4}[./-]\d{2}[./-]\d{2}/g;
      const dateMatch = this.notification.body.match(patternDate);

      if (dateMatch) {
        for (let i = 0; i < dateMatch.length; i++) {
          const detectedDate = moment(dateMatch[i]);
          const formattedDate = detectedDate.format('L');
          this.notification.body = this.notification.body.replace(dateMatch[i], formattedDate);
        }
      }
    },

    async loadNotificationData() {
      this.notification = await Rpc.Notifications.getNotificationById(this.notificationId);
      let userLocale = window.navigator.language;
      let m = moment(this.notification.created);
      this.dateOfNotification = m.locale(userLocale).format("L") + " " + m.locale(userLocale).format("LT");
      this.notificationIcon = this.notification.iconClass.substr(7, this.notification.iconClass.length);
      if (this.notification.type === "WARNING")
        this.notificationIconColor = "text-warning";
      else if (this.notification.type === "INFO")
        this.notificationIconColor = "text-primary";
      else if (this.notification.type === "TYPE_EXCLAMATION")
        this.notificationIconColor = "text-danger";
    },

    async markAsReed() {
      await Rpc.Notifications.markAsRead(this.notification.id);
      EventBus.$emit(Events.notificationsChanged);
      this.close();
    },

    async deleteNotification() {
      if (await DialogManager.yesNo($tr('notificationDetails.info.deleting','Deleting notification'),
          $tr('notificationDetails.sure.delete','Are you sure you want to delete this notification?'))) {
        await this.deleteOkSubmit();
        this.close();
      }
    },

    async deleteOkSubmit() {
      await Rpc.Notifications.deleteNotifications([this.notificationId]);
      EventBus.$emit(Events.notificationsChanged);
      this.close();
    },

    async moveToBusinessEntity() {
      if (this.entityId && this.entityClazz) {
        await FormsActions.editEntity(this.entityClazz, this.entityId);
      }
    },

    // async moveToOrderDetailsList() {
    //   if (this.entityId && this.entityClazz) {
    //     await FormsActions.showList(OrderDetails, {});
    //   }
    // },
    //
    // async moveToBudgetingPlannerPM() {
    //   let orderDetails = await Rpc.Forms.getEntity(this.entityClazz, this.entityId);
    //   let budgetingPlannerPM = await orderDetails.getBudgetingPlannerPMIdEntity();
    //   await FormsActions.editEntity(budgetingPlannerPM.__typename__, orderDetails.budgetingPlannerPMId);
    // }
  },

  props: {
    notificationId: {type: String, default: ""},
  },

  data: () => ({
    notification: new Notification(null),
    dateOfNotification: Date,
    notificationIcon: "",
    notificationIconColor: "",
    notificationWithTransition: false,
    // orderDetailsNotification: false,
    entityClazz: null,
    entityId: null,
  })

}
</script>
